import { toCapitelizeCase } from '@/tools/tocapitalizecase';
const FIO_ERROR_TEXT = 'Используйте кириллицу';

const validateFioData = {
  computed: {
    fioErrorText() {
      return this.$v.$invalid ? FIO_ERROR_TEXT : '';
    },

    firstNameErrorText() {
      const {
        first_name: { validateFio },
      } = this.v;
      return !validateFio ? FIO_ERROR_TEXT : '';
    },

    lastNameErrorText() {
      const {
        last_name: { validateFio },
      } = this.v;
      return !validateFio ? FIO_ERROR_TEXT : '';
    },
  },

  methods: {
    formatFio(value) {
      if (value.includes('.')) {
        const res = value.split('.');
        this[res[0]][res[1]] = toCapitelizeCase(this[res[0]][res[1]]);
      } else {
        this[value] = toCapitelizeCase(this[value]);
      }
    },
  },
};

export { validateFioData, FIO_ERROR_TEXT };



// WEBPACK FOOTER //
// ./src/mixins/validateFioData.js